import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import {
  initializeAuth, GoogleAuthProvider,
  indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "AIzaSyD6nEB8FqvCEPISjAXkjGvsimHMtFd3bjw",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "agumagu.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "babylog-3330f",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "babylog-3330f.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "806198190332",
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? "1:806198190332:web:97f7f7ac0ff2ffadf33779"
};

const app = initializeApp(firebaseConfig);

// M17: App Check via reCAPTCHA Enterprise, the web counterpart to the Android client's
// Play Integrity provider (BabyLogApplication.kt). Both stay in the Firebase console's
// **monitoring** mode (enforcement off) until both platforms are confirmed reporting valid
// tokens — see docs/plans/android-app.md's M17 section. No `VITE_RECAPTCHA_SITE_KEY` is
// bundled as a fallback the way the Firebase config values above are: unlike those, a
// reCAPTCHA Enterprise key doesn't exist until someone creates one in Google Cloud
// Console, so App Check simply stays uninitialized (every Firebase call still works,
// just unattested) until the env var is set.
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  if (import.meta.env.DEV) {
    // Per-developer-machine debug token, registered by hand in the App Check console;
    // `import.meta.env.DEV` is statically replaced at build time so this branch (and the
    // bypass it enables) never ships in a production bundle.
    (self as typeof self & { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const db = getFirestore(app);
// initializeAuth (not getAuth) with no popupRedirectResolver: the default
// resolver eagerly loads the ~93 KiB /__/auth/iframe.js helper and calls
// the Identity Toolkit getProjectConfig endpoint on every page load — even
// for anonymous sign-in, which never uses a popup/redirect. That chain was
// showing up as the tail of the LCP-blocking critical request path in
// PageSpeed Insights. Deferring it means it only loads when a user actually
// triggers signInWithPopup/linkWithPopup (see browserPopupRedirectResolver
// passed explicitly at those call sites in App.tsx).
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
});
export const storage = getStorage(app);
export const provider = new GoogleAuthProvider();
export const functions = getFunctions(app, "us-central1");
